module.exports = __webpack_public_path__ + "img/default.7d5080c6.png";